export const DE = 'de';
export const DEFAULT_LANGUAGE = DE;
